import {
  Typography,
  OutlinedInput,
  Grid,
  Select,
  MenuItem,
  RadioGroup,
  FormControlLabel,
  Radio,
  Box,
} from "@mui/material";
import { Controller, useFormContext } from "react-hook-form";
import { useEffect, useState } from "react";
import {  CANADA_STATES, US_STATES } from "../../utils/common/constants";
import InfoIcon from "../../assets/icons/information.svg";

const GuestContactInformation = () => {
 const { control, setValue, watch, getValues, clearErrors } = useFormContext();
 const [countryValue, setCountryValue] = useState("US");
 const handleCountryChange= (event: React.ChangeEvent<HTMLInputElement>) => {
      const selectedCountry = (event.target as HTMLInputElement).value;
      setCountryValue(selectedCountry);
      setValue("ZipCode","");
      clearErrors("ZipCode");
      setValue("State", selectedCountry == "US" ? US_STATES[0] : CANADA_STATES[0]);
 };

  const renderDropDownField = (
    label: string,
    name: "State",
    options: any[],
    defaultOption: any
  ) => (
    <>
      <Typography className="form-label" variant="h6" gutterBottom>
        {label}
      </Typography>
      <Controller
        name={name}
        control={control}
        defaultValue={defaultOption}
         rules={name == "State" ? {
          validate: (value) =>
          value?.value !== "Select" || `Please select State`
        } : {}
      }
       render={({ field, fieldState: { error } }) => (
        <>
          <Select
            defaultValue={defaultOption}
            value={field.value?.value ?? ""}
            onChange={(e) => {
              const selected = options.find((o) => o.value === e.target.value);
              field.onChange(selected);
            }}
             fullWidth
             MenuProps={{
               PaperProps: {
                 style: {
                   maxHeight: 250
                 }
               }
             }}
          >
            {options.map((option) => (
              <MenuItem key={option.value} value={option.value}>
                {option.label}
              </MenuItem>
            ))}
          </Select>
          {error && (
              <Typography
                className="error-text"
                color="error"
                fontSize="12px"
              >
                {error.message}
              </Typography>
            )}
            </>
        )}
      />
    </>
  );

  const renderRadioField = (
    label: string,
    name: string,
    defaultOption: string
  ) => (
    <>
      <Typography className="form-label" variant="h6" gutterBottom>
        {label}
      </Typography>
      <Controller
        name={name}
        control={control}
        defaultValue={defaultOption}
        render={({ field, fieldState: { error } }) => (
          <>
          <div><Box display={"flex"}>
            <RadioGroup
              aria-labelledby="demo-row-radio-buttons-group-label"
              name="row-radio-buttons-group"
              value={field.value??"US"}
              onChange={(e) => {
                field.onChange(e);
                handleCountryChange(e);
              }}
            >
              <FormControlLabel value="US" control={<Radio />} label="United States" />
              <FormControlLabel value="CA" control={<Radio />} label="Canada" />
            </RadioGroup>   
            {field.value == "US" ?
              <>
              {setCountryValue("US") }
              <img
                src={InfoIcon}
                alt="info"
                style={{ width: 16, height: 16, marginTop: "14px", marginRight: "7px" }}
              /><Typography style={{ paddingTop: "13px", fontSize: "13px" }}>Standard two-day shipping for <strong> $4.99 </strong> is applicable</Typography> </> 
              : <>
              {setCountryValue("CA")}
              <img
                src={InfoIcon}
                alt="info"
                style={{ width: 16, height: 16, marginTop: "14px", marginRight: "7px" }}
              /><Typography style={{ paddingTop: "13px", fontSize: "13px" }}> Standard two-day shipping for{" "}
                  <strong>$15.95</strong> is applicable</Typography></>
              }
              </Box></div>
               </>
            )}
          />
    </>
  );

  const renderInputField = (
    label: string,
    name: "AddressLine1" | "AddressLine2" | "City" | "ZipCode" | "RONo" | "PONo" | "TotalQuantityOrder" | "Instructions",
    placeholder: string
  ) => (
    <>
      <Typography className="form-label" variant="h6" gutterBottom>
        {label}
      </Typography>
      <Controller
        name={name}
        control={control}
        rules={name == "AddressLine1" ? {
          required: "Please enter Address Line 1",
          minLength: {
            value: 3,
            message: "Minimum 3 characters required"
          },
          maxLength: {
            value: 100,
            message: "Maximum 100 characters allowed"
          }
        } : name == "AddressLine2" ? {
            minLength: {
            value: 3,
            message: "Minimum 3 characters required"
          },
          maxLength: {
            value: 100,
            message: "Maximum 100 characters allowed"
          }
        } : name == "City" ? {
            required: "Please enter City",  
            minLength: {
            value: 3,
            message: "Minimum 3 characters required"
          },
          maxLength: {
            value: 50,
            message: "Maximum 50 characters allowed"
          }
        } : name == "ZipCode" ? {
            required: countryValue == "US" ? "Please enter Zip Code" : "Please enter Postal Code",  
            pattern: {
              value: countryValue == "US" ? /^\d{5}(-\d{4})?$/ : /^[A-Z]\d[A-Z][ -]?\d[A-Z]\d$/i,
              message: countryValue == "US" ? "Invalid US ZIP code" : "Invalid Canadian Postal Code",
            }
        } : name == "RONo" ? {
          minLength: {
            value: 3,
            message: "Minimum 3 characters required"
          },
          maxLength: {
            value: 15,
            message: "Maximum 15 characters allowed"
          }
        } : name == "PONo" ? {
          minLength: {
            value: 3,
            message: "Minimum 3 characters required"
          },
          maxLength: {
            value: 15,
            message: "Maximum 15 characters allowed"
          }
        } : name == "Instructions" ? {
          minLength: {
            value: 3,
            message: "Minimum 3 characters required"
          },
          maxLength: {
            value: 200,
            message: "Maximum 200 characters allowed"
          }
        } : name == "TotalQuantityOrder" ? {
              required: "Total quantity is required",
              min: { value: 1, message: "Quantity must be at least 1" },
              max: { value: 99, message: "Too many items" }
        } : {}
      }
  render={({ field, fieldState: { error } }) => (
    <>
          <OutlinedInput
            {...field}
            placeholder={placeholder}
            fullWidth
            autoComplete="off"
            value={field.value || ""}
            onChange={(e) => 
              {
                 if (field.name == "AddressLine1" || field.name == "AddressLine2") {
                    if (e.target.value.length <= 100) {
                      field.onChange(
                        e.target.value.slice(0, 100) || ""
                      )
                    }
                  }
                  else if (field.name == "PONo" || field.name == "RONo") {
                    if (e.target.value.length <= 15) {
                      field.onChange(
                        e.target.value.slice(0, 15) || ""
                      )
                    }
                  }
                  else if (field.name == "Instructions") {
                    if (e.target.value.length <= 200) {
                      field.onChange(
                        e.target.value.slice(0, 200) || ""
                      )
                    }
                  }
                  else if (field.name == "City") {
                    if (e.target.value.length <= 50) {
                      field.onChange(
                        e.target.value.slice(0, 50) || ""
                      )
                    }
                  }
                  else if (field.name == "ZipCode" && countryValue=="US") {
                    if (e.target.value.length <= 5) {
                      field.onChange(
                        e.target.value.slice(0, 5) || ""
                      )
                    }
                  }
                 else if (field.name == "ZipCode" && countryValue == "CA") {
                   if (/\s/.test(e.target.value)) {
                     if (e.target.value.length <= 7) {
                       field.onChange(
                         e.target.value.slice(0, 7) || ""
                       )
                     }
                   }
                   else{
                     if (e.target.value.length <= 6) {
                       field.onChange(
                         e.target.value.slice(0, 6) || ""
                       )
                     }
                   }
                 }
                 else if (field.name == "TotalQuantityOrder") {
                   if (e.target.value.length <= 2) {
                     field.onChange(
                       e.target.value.replace(/\D/g, "").slice(0, 2) || ""
                     )
                   }
                 }
                  else{
                    field.onChange(e.target.value || "")
                  }
            }}
            onBlur={(e) => {
                 if (field.name == "AddressLine1" || field.name == "AddressLine2" || field.name == "City" || field.name == "ZipCode" || field.name == "RONo" || field.name == "PONo" || field.name == "Instructions") {
                      const trimmed = e.target.value.trim();
                      setValue(field.name, trimmed, { shouldValidate: true });
                 }
              }}
            sx={{ height: "40px", fontSize: "14px", borderColor: error ? "red" : undefined }}
          />
            {error && (
              <Typography
                className="error-text"
                color="error"
                fontSize="12px"
              >
                {error.message}
              </Typography>
            )}
          </>
        )}
      />
    </>
  );

  return (
    <Grid container spacing={2}>
      <Grid  size={{ xs: 12, sm: 12, md: 12 }}>
        {renderRadioField("Country*", "CountryName", "US")}
      </Grid>
      <Grid size={{ xs: 12, sm: 6, md: 4 }}>
        {renderInputField("Address Line 1*", "AddressLine1", "Enter Address Line 1")}
      </Grid>

      <Grid size={{ xs: 12, sm: 6, md: 4 }}>
        {renderInputField("Address Line 2", "AddressLine2", "Enter Address Line 2")}
      </Grid>
      <Grid size={{ xs: 12, sm: 6, md: 4 }}>
        {renderInputField("City*", "City", "Enter City")}
      </Grid>

      <Grid size={{ xs: 12, sm: 6, md: 4 }}>
        {renderDropDownField(
          "State*",
          "State",
          countryValue == "US" ? US_STATES : CANADA_STATES,
          countryValue == "US" ? US_STATES[0]: CANADA_STATES[0]
        )}
      </Grid>

      <Grid size={{ xs: 12, sm: 6, md: 4 }}>
        {renderInputField((countryValue == "US" ? "Zip Code*" : "Postal Code*"), "ZipCode", (countryValue == "US" ? "Enter Zip Code" : "Enter Postal Code"))}
      </Grid>
      
      <Grid size={{ xs: 12, sm: 6, md: 4 }}>
        {renderInputField("RO#", "RONo", "Enter RO")}
      </Grid>
      <Grid size={{ xs: 12, sm: 6, md: 4 }}>
        {renderInputField("PO#", "PONo", "Enter PO")}
      </Grid>
      <Grid size={{ xs: 12, sm: 6, md: 4 }}>
        {renderInputField("Total Quantity Ordered*", "TotalQuantityOrder", "Enter Total Quantity Ordered")}
      </Grid>

      <Grid size={{ xs: 12, sm: 6, md: 4 }}>
        {renderInputField("Instructions", "Instructions", "Enter Instructions")}
      </Grid>

    </Grid>
  );
};

export default GuestContactInformation;
